import { Link } from 'react-router-dom';
import logo from '../assets/Logo-Little-stars-1-.png';
import './Footer.css';

export default function Footer() {
  return (
    <>
      {/* Wave ind i footer */}
      <div className="footer-wave">
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0,30 C360,60 1080,0 1440,30 L1440,60 L0,60 Z" fill="#1a1a2e" />
        </svg>
      </div>

      <footer className="footer">
        <div className="footer-container">

          {/* Logo + tagline */}
          <div className="footer-brand">
            <img src={logo} alt="Little-Stars logo" className="footer-logo-img" />
            <p className="footer-tagline">Stedet hvor familier samles</p>
            <a
              href="https://www.instagram.com/littlestars.dk/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social"
            >
              📸 Instagram
            </a>
          </div>

          {/* Navigation */}
          <div className="footer-col">
            <h4>Navigation</h4>
            <Link to="/">Forside</Link>
            <Link to="/priser">Priser</Link>
            <Link to="/faciliteter">Faciliteter</Link>
            <Link to="/om-os">Om os</Link>
          </div>

          {/* Adgang */}
          <div className="footer-col">
            <h4>Adgang</h4>
            <Link to="/bliv-medlem">Bliv medlem</Link>
            <Link to="/login">Log ind</Link>
            <Link to="/priser">Dagsbillet</Link>
            <Link to="/priser">Lokaleudlejning</Link>
            <Link to="/handelsbetingelser">Handelsbetingelser</Link>
          </div>

          {/* Kontakt */}
          <div className="footer-col">
            <h4>Kontakt</h4>
            <a href="mailto:info@little-stars.dk">info@little-stars.dk</a>
            <a href="tel:31525943">31 52 59 43</a>
            <span>Hovedvejen 8</span>
            <span>8920 Randers NV</span>
          </div>

        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Little-Stars · Alle rettigheder forbeholdes</p>
        </div>
      </footer>
    </>
  );
}
